import { create } from "zustand";

const STORAGE_KEY = "gaole_bo_sidebar_pinned";

function loadPinned(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function persistPinned(pinned: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, pinned ? "true" : "false");
  } catch {
    // ignore quota / private mode
  }
}

interface ShellSidebarState {
  pinned: boolean;
  togglePinned: () => void;
}

export const useShellSidebar = create<ShellSidebarState>((set) => ({
  pinned: loadPinned(),
  togglePinned: () =>
    set((state) => {
      const pinned = !state.pinned;
      persistPinned(pinned);
      return { pinned };
    }),
}));
